module.exports = __webpack_public_path__ + "img/basket-icon.6bae1373.svg";